import { PrimaryButton } from "Element/Button";
import styled from "styled-components";

export const DogeBoxWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin-bottom: 24px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
  `}
`;
export const DogeBoxImgWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  height: 182px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 158px;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    height: 168px;
  `}
`;

export const DogeBoxImgWrapperDesktop = styled(DogeBoxImgWrapper)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`;

export const DogeBoxImgWrapperIpad = styled(DogeBoxImgWrapper)`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: flex;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `}
`;

export const DogeBoxImgWrapperMobile = styled(DogeBoxImgWrapper)`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: flex;
  `}
`;
export const DogeBoxImg = styled.img`
  position: absolute;
  width: 750px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 600px;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 215px;
  `}
  :nth-child(1) {
    z-index: 0;
  }
  :nth-child(2) {
    z-index: 2;
  }
`;
export const DogeHeadImgWrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: -12px;
  width: 675px;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 545px;
    top: -6px;
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 180px;
    top: -2px;
    justify-content: flex-start;
  `}
`;
export const DogeHeadImg = styled.img`
  width: 105px;
  :nth-child(1) {
    margin-left: 0;
  }
  :nth-child(n + 20) {
    display: none;
  }
  margin-left: -74px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 80px;
    margin-left: -54px;

  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 58px;
    margin-left: -32px;
    :nth-child(1) {
      margin-left: 4px;
    }
    :nth-child(n+6) {
      display:none;
    }
  `}
`;

export const MintInfoWrapper = styled.div`
  width: 650px;
  position: absolute;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 20px;
  top: 64px;
  margin-left: -35px;

  .mint-info {
    img {
      margin-right: 8px;
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width:500px;
    padding: 8px;
    justify-content: center;
    top: 56px;
    margin-left: -26px;
    .mint-info{
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: center;
  }
    }
  `}

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width:154px;
    padding: 8px;
    justify-content: start;
    top: 42px;
    margin-left: -12px;
    .mint-info{
      flex-direction: column;
      align-items: start;
    }
  `}
`;

export const TokenValue = styled.h2`
  color: ${({ theme }) => theme.colors.neutral80};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 18px;
  `}
`;

export const StyledCounter = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.neutral100};
  ${({ theme }) => theme.fontStyle.button}
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  width: 100px;
  background: transparent;
  outline: none;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 190px;
  `}
`;

export const CounterButtonWrapper = styled.div`
  display: none;
  justify-content: center;
  margin-bottom: 24px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: flex;
  `}
  .btn-sub {
    margin-right: 12px;
  }
  .btn-add {
    margin-left: 12px;
  }
`;

export const CounterButton = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  svg {
    width: 20px;
    height: 20px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: fit-content;
  `}
`;
